<div>
  <app-control-selectors *ngIf="sites && programs && !holdUpdates" [sites]="sites" [programs]="programs" [filter]="filter" (paramEvent)="onParamChange($event)"></app-control-selectors>
</div>
<div class="chart-container">
  <div *ngIf="!loading">
    <app-activity-chart *ngIf="sites && !holdUpdates" [sites]="sites" [programs]="programs" [activities]="activities" [filterEvent]="filter"></app-activity-chart>
  </div>
  <div class="text-center" *ngIf="loading">
    <br />
    <app-calibrant-load [small]="true"></app-calibrant-load>
  </div>
</div>

